exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1lsQFOtdyGAm9Ts7Qigo37 .ms-DatePicker-event--without-label,._1lsQFOtdyGAm9Ts7Qigo37 input{color:\"[theme:neutralTertiary, default:#a6a6a6]\"}html[dir] ._1-vsBCK8-GUwa72eRGIMYG .ms-TextField-fieldGroup{background-color:transparent}", ""]);

// exports
exports.locals = {
	"grey": "_1lsQFOtdyGAm9Ts7Qigo37",
	"datepickerInput": "_1-vsBCK8-GUwa72eRGIMYG"
};